import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import params from '../config/Params';
import { getItemFromLocalStorage } from '../utils/storageUtils';
import Loading from '../components/Loading';
import { toast } from 'react-toastify';
import Loader from '../components/Loader';

function MySubscription() {

  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [subscriptionDetail, setSubscriptionDetail] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [hostSubscriptionId, setHostSubscriptionId] = useState(null);

  useEffect(() => {
    const fetchMySubscriptions = async () => {

      const hostData = getItemFromLocalStorage('hostProfile');
      let formData = new FormData();
      formData.append('token', hostData.host_access_token);

      try {
        const response = await axios({
          method: 'post',
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          url: `${params.baseURL}${params.endpoints.mySubscriptions}`,
          data: formData
        });

        if (response.data.items && Array.isArray(response.data.items)) {
          console.log(response.data);
          setData(response.data.items);
        } else {
          setError(response.message || 'Error in fetching data.');
        }
      } catch (error) {
        return <div>
          <div className='text-center text-uppercase'>
              <img src='/assets/img/no_subscription_found.png' alt='' style={{width:'300px'}} className='img-fluid' />
              <h4>SUBSCRIPTION LOADING ERROR</h4>
              <p>We’re currently experiencing an issue fetching your subscriptions. Please try again later while we work to resolve the problem. Thank you for your patience!</p>
            </div>
        </div>
      } finally {
        setLoading(false);
      }
    };

    fetchMySubscriptions();
  }, []);

  const handleRenewClick = async (subscriptionId, hostSubscriptionId) => {

    setHostSubscriptionId(hostSubscriptionId);
    const hostData = getItemFromLocalStorage('hostProfile');
    const formData = new FormData();
    formData.append('token', hostData.host_access_token);
    formData.append('subscription_id', subscriptionId);
  
    try {
      const response = await axios({
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        url: `${params.baseURL}${params.endpoints.subscriptionDetails}`,
        data: formData
      });
      if (response.data.status === 'found') {
        setSubscriptionDetail(response.data.subscription_info);
        setShowPopup(true);
      }
    } catch (error) {
      console.error("Error fetching subscription detail:", error);
    }
  };  

  const handleConfirmRenewal = async () => {
    const hostData = getItemFromLocalStorage('hostProfile');
  
    if (!subscriptionDetail || !selectedPlan) {
      alert("Please select a plan to continue.");
      return;
    }
  
    const formData = new FormData();
    formData.append('token', hostData.host_access_token);
    formData.append('captain_subscription_id', hostSubscriptionId);
    formData.append('price_variant_id', selectedPlan);
  
    try {
        const response = await axios({
            method: 'post',
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            url: `${params.baseURL}${params.endpoints.renewSubscription}`,
            data: formData
        });
        if (response.data.status === 'ok') {
            openRazorpay(response.data);
            setShowPopup(false);
            setHostSubscriptionId(null);
          } else if (response.data.status === 'error') {
            toast.error(response.data.list);
          } else {
            setError('Error in saving data.');
          }
        
    } catch (error) {
      toast.error('Renewal failed. Please try again later.');
      console.error("Renewal Error:", error);
    }
  };  

  const openRazorpay = (response) => {
    const { pgKey, orderInfo, captain_subscription_info } = response;

    const options = {
      key: pgKey,
      amount: Number(captain_subscription_info.final_total) * 100,
      currency: captain_subscription_info.subscription_currency,
      name: "Stay",
      description: captain_subscription_info.subscription_name,
      order_id: orderInfo,
      handler: function (razorpayResponse) {
        verifyPayment({
          host_subscription_id: captain_subscription_info.host_subscription_id,
          razorpay_payment_id: razorpayResponse.razorpay_payment_id,
          razorpay_order_id: razorpayResponse.razorpay_order_id,
          razorpay_signature: razorpayResponse.razorpay_signature,
        });
      },
      prefill: {
        name: "Host Name",
        email: "host@example.com",
        contact: "9999999999",
      },
      theme: {
        color: "#00AEEF",
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  };

  const verifyPayment = async (paymentData) => {
    const hostData = getItemFromLocalStorage('hostProfile');

    let formData = new FormData();
    formData.append('token', hostData.host_access_token);
    formData.append('payment_id', paymentData.razorpay_payment_id);

    try {
      const response = await axios({
        method: 'post',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        url: `${params.baseURL}${params.endpoints.verifyPg}`,
        data: formData
      });

      if (response.data.status === "ok") {
        toast.success("Subscription renewed successfully!");
        setTimeout(() => {
            navigate('/my-subscription');
        }, 1500);
      } else {
        toast.error("Payment verification failed!");
      }
    } catch (error) {
      console.error("Verification failed:", error);
    }
  };

  if (loading) {
    return <Loader />;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div>
      <div className='ms-section'>
      {data.length > 0 ? (<>
        {data.map(item => (
            <div className='ms-box'>
                <div className='ms-box-header'>
                    <h4>{item.subscription_name} -
                      <span className='ms-price-title'> {item.subscription_final_rate_display} {item.subscription_currency} {item.days_in_month}</span>
                    </h4>                               
                    <div className='ms-body-flex-item'>
                        <p className={`ms-purchase-status ${item.subscription_status === 2 ? 'active' : 'inactive'}`}>{item.subscription_status_display}</p>
                        <p className={'ms-purchase-status'} style={{background:'#000',color:'#fff',cursor:'pointer'}} onClick={() => handleRenewClick(item.subscription_id, item.host_subscription_id)} >Renew</p>
                        <a href={item.invoice_link} target='_blank' className={'ms-purchase-status'} style={{background:'#000',color:'#fff'}}>Invoice</a>
                    </div>
                </div>
                <div className='ms-box-body'>
                    <div className="row ms-features">
                        <h5 className='ms-price-title'>Features</h5>
                        {item.subscription_features.map(feature => (
                            <div className="col-md-3 ms-feature">
                                <div className="ms-feature-point">
                                    {feature.feature_code === 'COMMISSION5' && (
                                      <img src='/assets/img/icons/fs_post_active.svg' alt='' className='subs-icon' />
                                    )}
                                    <div className='mspfts'>
                                      <p>{feature.feature_title}</p>
                                      <span>{feature.usage}</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className='ms-box-footer'>
                    <div className='ms-body-flex-item'>
                        <p>Purchased on : {item.subscription_purchased_on}</p>
                        <p>Valid till : {item.subscription_valid_till_display}</p>
                    </div>
                </div>
            </div>
        ))}
        </>) : (<>
            <div className='text-center text-uppercase'>
              <img src='/assets/img/banners/no_active_subscription_1.webp' alt='' style={{width:'500px'}} className='img-fluid' />
            </div>
        </>)}
      </div>
      {showPopup && subscriptionDetail && (
        <div className='modal-overlay'>
            <div className='modal-content'>
                <div className="modal-header mb-4">
                    <h5 className="modal-title">Renew Subscription - {subscriptionDetail.subscription_name}</h5>
                    <span className="popup-close" onClick={() => setShowPopup(false)}>&times;</span>
                </div>

                <div className="modal-body">
                    {subscriptionDetail.subscription_pricing.map((option, index) => (
                        <div key={option.price_variant_id} className='radio-option'>
                        <input
                            type='radio'
                            name='plan'
                            style={{marginRight:'10px'}}
                            value={option.price_variant_id}
                            checked={selectedPlan === option.price_variant_id}
                            onChange={() => setSelectedPlan(option.price_variant_id)}
                        />
                        <label>
                            {option.final_price_display_with_validity}
                        </label>
                        </div>
                    ))}
                </div>

                <div className="modal-footer">
                    <button type="button" className="btn" onClick={() => setShowPopup(false)}>Cancel</button>
                    <button className="btn btn-modal" onClick={handleConfirmRenewal} disabled={!selectedPlan}>Select</button>
                </div>
            </div>
        </div>
        )}
    </div>
  )
}

export default MySubscription;